import type { DialogueSpeaker } from "@hamlak/shared";
import { NarrativeText } from "@/components/NarrativeText";
import type { Speaker } from "./BlockRenderer";

/** 화자 id → 표시 화자. 'user' 는 내 말풍선, 'main' 은 플롯 캐릭터(who 행). 조연(cast)이 생기면 여기서 찾는다 (AC0-215) */
export const resolveSpeaker = (id: DialogueSpeaker, main: Speaker | undefined): { kind: "user" } | { kind: "character"; speaker: Speaker | undefined } =>
  id === "user" ? { kind: "user" } : { kind: "character", speaker: main };

/** dialogue{speaker, body}: 채팅 메시지와 같은 렌더러·서식 규약(docs/narrative-format.md). 캐릭터는 who 행 + 왼쪽, 유저는 채팅 내 메시지처럼 오른쪽(대사는 내 말풍선, `*…*` 지문은 말풍선 밖, AC0-254). */
export function DialogueBlock({ body, speaker: id, main }: { body: string; speaker: DialogueSpeaker; main?: Speaker | undefined }) {
  const who = resolveSpeaker(id, main);
  if (who.kind === "user") {
    return <NarrativeText text={body} mine className="block block--dialogue" data-testid="block-dialogue-user" />;
  }
  const speaker = who.speaker;
  return (
    <NarrativeText
      text={body}
      {...(speaker ? { name: speaker.name, ...(speaker.avatarUrl ? { avatar: <img src={speaker.avatarUrl} alt="" /> } : {}) } : {})}
      className="block block--dialogue"
      data-testid="block-dialogue"
    />
  );
}
